<template>
  <div>
    <!-- <div class="section1">
      <div class="s1-left">
        <div
          class="left-1"
          v-for="(item, index) in dataList1.slice(0, 5)"
          :key="index"
        >
          <div class="left1-id">
            <div :class="left[index]">
              {{ item.sort }}
            </div>
            <div>
              <img :src="item.img" class="img1" :onerror="defaultImg" />
            </div>
            <div>{{ item.name }}</div>
          </div>

          <div class="left1-number" :class="sstt[index]">{{ item.rightf }}</div>
        </div>
      </div>
      <div class="s1-left">
        <div
          class="left-1"
          v-for="(item, index) in dataList1.slice(5, 10)"
          :key="index"
        >
          <div class="left1-id">
            <div class="sort">
              {{ item.sort }}
            </div>
            <div>
              <img :src="item.img" class="img1" :onerror="defaultImg" />
            </div>
            <div>{{ item.name }}</div>
          </div>

          <div class="left1-number">{{ item.rightf }}</div>
        </div>
      </div>
    </div> -->
    <div class="section-bottom">
      <first-component :classifyId="18"></first-component>
    </div>
  </div>
</template>
<script>
import lib from '../api/index';
export default {
  data() {
    return {
      defaultImg:
        'this.src="' + require('../../static/image/home/defaultImg.jpg') + '"',
      dataList1: [],
      sstt: ['one', 'two', 'three'],
      left: ['left1', 'left2', 'left3']
    };
  },
  computed: {
    color1() {}
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      lib
        .RankingAnswers({
          params: {
            page: 1,
            size: 10
          }
        })
        .then(r => {
          console.log('党风廉政', r);
          this.dataList1 = r.data.records;
          //   this.test();
          let i = 1;
          this.dataList1.forEach(item => {
            item.sort = i;
            i++;
          });
          console.log(this.dataList1);
        });
    }
  }
};
</script>
<style scoped>
.section-bottom{
  width: 1100px;
  margin: auto;
  /* margin-top: 50px; */
}
.one {
  color: red;
}
.two {
  color: orangered;
}
.three {
  color: yellow;
}

.left1-number {
  margin-right: 20px;
  font-size: 18px;
}
.img1 {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 10px;
}
.left1-id {
  width: 60%;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.left-1 {
  width: 100%;
  height: 70px;
  border-bottom: 1px solid gainsboro;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.s1-left {
  width: 45%;
  height: 100%;
  /* background-color: darkcyan; */
}
.section1 {
  width: 1100px;
  height: 370px;
  margin: auto;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  /* background-color: cornsilk; */
}

.all-content {
  width: 1100px;
  margin: 0 auto;
}
.location {
  background-color: rgb(243, 243, 243);
  background-image: url(../assets/img/bg.jpg);

  padding-top: 10px;
  padding-bottom: 10px;
}
.break {
  display: inline-block;
}
.el-icon-location-outline {
  margin-left: 10px;
}
.now-location {
  display: inline-block;
  font-size: 13px;
  position: relative;
  top: -2px;
}
.left-1 .left1-number:nth-child(1) {
  color: red;
}
.left1 {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: red;
  border-radius: 50%;
  margin-left: -10px;
}
.left2 {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: orangered;
  border-radius: 50%;
  margin-left: -10px;
}
.left3 {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: yellow;
  border-radius: 50%;
  margin-left: -10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PartyConstruction.vue